/**
 * One chapter's notes as pointers under heading → sub-heading.
 * Shared by the floating notepad and the Notes Taken page.
 */
import { Trash2 } from 'lucide-react';

export function NoteTree({ headings = [], onDelete, compact = false }) {
  return (
    <div className={compact ? 'space-y-2.5' : 'space-y-4'}>
      {headings.map(h => (
        <div key={h.heading} data-testid={`note-heading-${h.heading}`}>
          <p className={`font-heading font-bold text-slate-900 ${compact ? 'text-[13px]' : 'text-sm'} flex items-center gap-1.5`}>
            <span className="w-1.5 h-4 rounded-full bg-amber-400" /> {h.heading}
          </p>
          {h.subheadings.map(s => (
            <div key={s.subheading || '_'} className="mt-1 ml-3">
              {s.subheading && <p className="font-heading text-[12px] font-semibold text-amber-700 mt-1">{s.subheading}</p>}
              <ul className="mt-0.5 space-y-1">
                {s.points.map(p => (
                  <li key={p.note_id} className="group flex items-start gap-2 text-[12.5px] font-body text-slate-700 leading-snug" data-testid={`note-point-${p.note_id}`}>
                    <span className="mt-[0.45em] w-1.5 h-1.5 rounded-full bg-slate-400 flex-shrink-0" />
                    <span className="flex-1">{p.text}</span>
                    {onDelete && (
                      <button onClick={() => onDelete(p.note_id)} data-testid={`note-delete-${p.note_id}`}
                        className="opacity-0 group-hover:opacity-100 focus:opacity-100 text-slate-300 hover:text-rose-500 transition-opacity" title="Remove this point">
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default NoteTree;
